import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    header: 'Randomizer',
    categorySelect: {
      label: 'Your favourite category',
    },
  },
}
